import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { ExclusionTime } from '../../../shared/definitions';

import {
  TXTWCL_You_have_chosen_a_1_year_Self__ELL,
  TXTWCL_You_have_chosen_a_N0_days_Self_ELL,
  TXTWCL_You_have_chosen_a_N0_hours_Sel_ELL,
  TXTWCL_You_have_chosen_a_N0_years_Sel_ELL
} from './ExclusionTopMessage.messages.json';

interface Props {
  daysExclude: number;
}

const ExclusionTopMessage: React.FC<Props> = ({ daysExclude }) => {
  switch (true) {
    case daysExclude === ExclusionTime.HalfDay:
      return (
        <Translation
          tagName="p"
          {...TXTWCL_You_have_chosen_a_N0_hours_Sel_ELL}
          values={{ 0: 12 }}
        />
      );
    case daysExclude === ExclusionTime.OneDay:
      return (
        <Translation
          tagName="p"
          {...TXTWCL_You_have_chosen_a_N0_hours_Sel_ELL}
          values={{ 0: 24 }}
        />
      );
    case [
      ExclusionTime.SevenDays,
      ExclusionTime.ThirtyDays,
      ExclusionTime.SixtyDays,
      ExclusionTime.NinetyDays,
      ExclusionTime.HundredEightyDays
    ].includes(daysExclude):
      return (
        <Translation
          tagName="p"
          {...TXTWCL_You_have_chosen_a_N0_days_Self_ELL}
          values={{ 0: daysExclude }}
        />
      );
    case daysExclude === ExclusionTime.OneYear:
      return (
        <Translation
          tagName="p"
          {...TXTWCL_You_have_chosen_a_1_year_Self__ELL}
          values={{ 0: daysExclude }}
        />
      );
    case daysExclude > ExclusionTime.OneYear:
      return (
        <Translation
          tagName="p"
          {...TXTWCL_You_have_chosen_a_N0_years_Sel_ELL}
          values={{ 0: daysExclude / ExclusionTime.OneYear }}
        />
      );
    default:
      return (
        <Translation
          tagName="p"
          {...TXTWCL_You_have_chosen_a_1_year_Self__ELL}
          values={{ 0: daysExclude }}
        />
      );
  }
};

export default ExclusionTopMessage;
